import angular from 'angular';
import { CallActionsController } from './call-actions.controller';
import template from './call-actions.html';
import micNotification from './mic-notification/mic-notification';
import qualityMenu from './quality-menu/quality-menu';
import qualityNotification from './quality-notification/quality-notification';
import toggleViewButton from './toggle-view-button/toggle-view-button';
const callActionsComponent = {
    template,
    bindings: {
        isPatient: '<',
        isGalleryView: '<',
        onToggleGalleryView: '&',
    },
    controller: CallActionsController,
};
export default angular
    .module('doxy.videoChat.callActions', [
    micNotification,
    qualityNotification,
    qualityMenu,
    toggleViewButton,
])
    .component('callActions', callActionsComponent).name;
